import axios from "axios";

class LogServices {

    appName(){
        return "APP PILAR";
    }

    serverLog() {
        return "https://logs.fire-bots.com/logs";
    }
    
    log(actionIn, userIn, messageIn, logIn) {
        try {
        var messageStr = JSON.stringify(messageIn);
        var postData = { action: actionIn, user: userIn, origin: this.appName(), type: 0, message:  messageStr, logs: logIn}
        axios.post(this.serverLog(), postData, {headers: {'USERNAME': 'admin_json',
    'PASSWORD':'askdma8383dnaskd8pasjdamsd9'}})
    .then((resp)=>{
        console.log("OK");
        console.log(resp);
        })
    .catch((resp2)=>{
        console.log("Error sending log");
        console.log(resp2);
    });
} catch(error){
    console.log(error);
}
    }

}

export default new LogServices();